<template>
  <div>
    <!-- <div class="subtitle mb20 mt20">人群统计</div> -->
    <div v-for="(item, index) in localData" :key="index">
      <div class="p10 box-s br10 mr10 ac mb10">
        <div class="ac">
          <div class="ac mr20">
            <div class="no-wrap mr20">大屏显示标题：</div>
            <el-input v-model="item.name" class="w300" />
          </div>
          <div class="ac">
            <div class="no-wrap mr20">表单收集名称：</div>
            <!-- <el-input v-model="item.key" class="w300" /> -->

            <el-select v-model="item.key" placeholder="请选择" @change="$emit('input', localData)">
              <el-option v-for="item in dataOption" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </div>
        </div>

        <i class="el-icon-delete ml10" style="color: red" @click="deleteItemFunc(localData, index)"></i>
      </div>
    </div>

    <el-button type="primary" @click="addOptions(localData, {name: '', key: ''})" size="mini">新增选项</el-button>
  </div>
</template>

<script>
import {http_post} from '@/api/api'

export default {
  props: {
    value: {
      type: [Array],
      default: () => []
    },
    MaxNum: {
      type: [Number],
      default: 10
    }
  },

  data() {
    return {
      localData: [],
      dataOption: []
    }
  },

  created() {
    this.localData = JSON.parse(JSON.stringify(this.value))
    http_post('/api/admin/dashboard/get_options', {}).then(res => {
      this.dataOption = res.data
    })
  },
  methods: {
    deleteItemFunc(rows, index) {
      this.$confirm('确认删除？', '提示', {type: 'warning'})
        .then(() => {
          rows.splice(index, 1) // 删除项
          this.$emit('input', rows) // 更新父组件的绑定值（这里使用 rows 而不是 row，因为你操作的是 rows 数组）
        })
        .catch(() => {
          this.$message.info('已取消删除') // 取消删除
        })
    },
    addOptions(row, item) {
      if (row.length >= this.MaxNum) {
        this.$message.info('最多添加' + this.MaxNum + '个选项')
      } else {
        row.push(JSON.parse(JSON.stringify(item)))
        this.$emit('input', row)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
